import Fetch from "../../utils/Fetch"

export default {
    namespaced: true,
    state: {
        freeDayList: [],
        pawnsList: [],
        freeTimeList: [],
    },
    mutations: {
        setFreeDay(state, data) {
            if (!data) return
            state.freeDayList = data
        },
        setFreeTime(state, data) {
            if (!data) return
            state.freeTimeList = data.map(item => ({
                ...item,
                formattedTime: `${item.timeFrom.slice(11, 16)}-${item.timeTo.slice(11, 16)}`
              }));
        },
        setPawnsList(state, data) {
            if (!data) return
            state.pawnsList = data
        }
    },
    actions: {
        async loadInitialData({commit}) {
            const response = await Fetch('forms/book-pawn-initials/')
            if (response.success) {
                commit('setPawnsList', response.data.pawns || [])
                commit('setFreeDay', response.data.dates || [])
            }
            return {
                ...response
            }
        },
        async loadFreeTime({commit}, {date, city}) {
            if (!date || !city) return
            if (typeof date === 'object') {
                date = date.toISOString()
            }
            let response = await Fetch(`forms/book-pawn-intervals/?date=${date}&pawn_id=${city}`)
            if (response.success) {
                commit('setFreeTime', response.data)
            }
        },
    },
    getters: {
        getFreeDay: state => state.freeDayList,
        getPawnsList: state => state.pawnsList,
        getFreeTime: state => state.freeTimeList,
    }
}
